type ExternalLinkIconProps = {
  className?: string;
};

const ExternalLinkIcon = ({
  className = 'external-link-icon',
}: ExternalLinkIconProps) => (
  <svg
    className={className}
    aria-hidden="true"
    viewBox="0 0 256 256"
    fill="none"
  >
    <line
      x1="136"
      y1="120"
      x2="216"
      y2="40"
      stroke="currentColor"
      strokeWidth="12"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline
      points="216 104 215.99 40.01 152 40"
      stroke="currentColor"
      strokeWidth="12"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M184,136v72a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h72"
      stroke="currentColor"
      strokeWidth="12"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ExternalLinkIcon;
